import React, {useContext} from "react";
import { Modal, Button } from "react-bootstrap";
import { ActivitiesContext } from "../../context/ActivitiesContext";

const LateActivityModal = ({ show, onHide, handleUpdate, modalData, updatedItinerary = [] }) => {
    const {changeAllActivities} = useContext(ActivitiesContext);

  const handleUpdateItinerary = () => {
    if (modalData?.multi_day_itinerary?.length > 0) {
      changeAllActivities(modalData.multi_day_itinerary);
    }
    onHide(); // Close the modal after updating
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Confirm Activity Change
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
            Are you sure you want to switch from your current activity (<strong>{modalData?.old_activity_name || ""}</strong>) to the <strong>{modalData?.new_activity_name || "the new one"}</strong>?
            <br/>
            <br/>
            This change will update your itinerary accordingly.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          No, keep the old activity
        </Button>
        <Button
          variant="primary"
          onClick={handleUpdateItinerary}
          disabled={updatedItinerary.length === 0}
        >
          Yes, switch activity
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LateActivityModal;
